import React, { HTMLAttributes } from 'react';

import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import {
  WysiwygField,
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import { Video, Button } from '../../../../components';
import useClasses from '../../../../hooks/useClasses';
import { MediaFileField } from '../../../../types';

import './style.scss';

interface Props extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  title: string;
  body: string;
  linkTitle: string;
  link: string;
  video: string;
  svg?: ImmutableEntity<MediaFileField>;
}

const LandingPageHero: React.FC<Props> = ({
  title, body, link, linkTitle, video, svg, className,
}) => {
  const { buildClass, joinClasses } = useClasses('LandingPageHero');
  const svgDescription = svg.get('description', '');
  const svgSource = svg.get('url', '');

  const gridClassesMedia = 'col-lg-5 col-md-6 col-sm-12 col-12';
  const gridClassesContent = 'col-lg-6 offset-lg-1 col-md-6 col-sm-12 col-12';

  return (
    <div className={joinClasses(buildClass(), className)}>
      <Container>
        <div className="row">
          <div className={joinClasses(buildClass('media-container'), gridClassesMedia)}>
            { svgSource && <img width="100%" src={svgSource} alt={svgDescription} className={buildClass('svg')} /> }
            { video && <Video url={video} className={buildClass('video')} /> }
          </div>
          <div className={joinClasses(buildClass('content-container'), gridClassesContent)}>
            <h1 className={buildClass('title')}>
              { title }
            </h1>
            {body && (
              <WysiwygField
                className={buildClass('body')}
                property="schema:text"
                html={body}
              />
            )}
            {(linkTitle && link) && (
              <Button href={link} className={buildClass('button')}>
                { linkTitle }
              </Button>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default LandingPageHero;
